// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__2aULa","loader":"style_loader__1phUE"};